
import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ContactForm } from '../components/ContactForm';

const Contact = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      
      <main className="flex-1 container mx-auto px-4 md:px-6 py-20">
        <div className="max-w-2xl mx-auto text-center">
          <h1 className="text-4xl font-bold mb-8 bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/80">
            Kontakt os
          </h1>
          
          <p className="text-lg mb-8">
            Har du spørgsmål eller feedback? Vi vil meget gerne høre fra dig. Udfyld formularen nedenfor, så vender vi tilbage hurtigst muligt.
          </p>
          
          <ContactForm />
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
